var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 46.2V59.4H19.8V66H0V46.2H6.6ZM66 46.2V66H46.2V59.4H59.4V46.2H66ZM18.15 16.5C18.15 20.4385 19.7146 24.2156 22.4995 27.0005C25.2844 29.7854 29.0615 31.35 33 31.35C36.9385 31.35 40.7156 29.7854 43.5005 27.0005C46.2854 24.2156 47.85 20.4385 47.85 16.5H54.45C54.4507 20.425 53.3745 24.275 51.3386 27.6306C49.3026 30.9863 46.3849 33.719 42.9033 35.5311L42.9 56.1H23.1V35.5344C19.6173 33.7224 16.6986 30.9894 14.662 27.6331C12.6254 24.2768 11.549 20.4259 11.55 16.5H18.15ZM33 9.9C35.188 9.9 37.2865 10.7692 38.8336 12.3164C40.3808 13.8635 41.25 15.962 41.25 18.15C41.25 20.338 40.3808 22.4365 38.8336 23.9836C37.2865 25.5308 35.188 26.4 33 26.4C30.812 26.4 28.7135 25.5308 27.1664 23.9836C25.6192 22.4365 24.75 20.338 24.75 18.15C24.75 15.962 25.6192 13.8635 27.1664 12.3164C28.7135 10.7692 30.812 9.9 33 9.9ZM19.8 0V6.6L6.6 6.5967V19.8H0V0H19.8ZM66 0V19.8H59.4V6.6H46.2V0H66Z",
    fill: "#72C0B0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.2ca28982bf67e170f6bd4a9499bae9b5.svg";
export { ForwardRef as ReactComponent };